import { useTheme, Box, Typography, alpha, Slide, Dialog, IconButton } from "@mui/material";
import { useSelector } from "react-redux";
import React from "react";
import CloseIcon from '@mui/icons-material/Close';
import { TransitionProps } from "@mui/material/transitions";
import LineupSelector from "./LineupSelector";
import { IRootState } from "../../store/reducer";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const LineUpSelectorModal = ({ open, onClose }: { open: boolean, onClose: () => void }) => {
  return (
    <React.Fragment>
      <Dialog fullScreen open={open} onClose={onClose}
        TransitionComponent={Transition}
        sx={{
          '& .MuiBackdrop-root': {
          backgroundColor: '#363636',
        },
        '& .MuiPaper-root': {
            backgroundColor: '#363636',
          }
        }}
      >
        <Box style={{ width: '100%', justifyContent: 'flex-end', display: 'flex', color: 'white' }}>
          <IconButton
            edge="start"
            color="inherit"
            onClick={onClose}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </Box>
        <LineupSelector />
      </Dialog>
    </React.Fragment>
  );
}


const MobileLineupSelector = () => {
  const { optimizerState: { entries, selectedEntry, isEntryView } } = useSelector((state: IRootState) => state.pick6);
  const theme = useTheme();
  const [openModal, setOpenModal] = React.useState(false);
  let entry = entries[selectedEntry ?? 0];
  const league = entry?.outcomes?.[0]?.leagueCode;
  const showGenerate = !entry || !entry.outcomes || entry?.outcomes?.length === 0 || !isEntryView;
  return (
    <>
      <LineUpSelectorModal open={openModal} onClose={() => setOpenModal(false)} />
      {/* BDK FUTURE Remove this box below it was just a quick fix for v1 to make things look more noticeable */}
      <Box id='to-be-removed-in-v2' sx={{
        borderRadius: '10px 10px 0 0',
        marginBottom: '5px',
        alignItems: 'center', gap: '10px', bottom: 0,
        boxSizing: 'border-box',
        left: 0, right: 0, zIndex: 5, position: 'fixed',
        width: '100%', height: '37px', padding: '10px',
        borderBottom: `1px ${alpha(theme.palette.common.white, 0.15)} solid`,
        flexDirection: 'column', display: 'inline-flex',
        backgroundColor: alpha('#101010', 1),
      }}>
        <Box onClick={() => setOpenModal(true)}
          sx={{
            borderRadius: '10px 10px 0 0',
            alignItems: 'center', gap: '10px',
            bottom: 0,
            left: 0, right: 0, zIndex: 5, position: 'fixed',
            boxSizing: 'border-box',
            width: '100vw', height: '37px', padding: '10px',
            borderBottom: `1px ${alpha(theme.palette.common.white, 0.15)} solid`,
            flexDirection: 'column', display: 'inline-flex',
            backgroundColor: showGenerate ? alpha('#005cce', 0.5) : alpha('#101010', 1),
            border: showGenerate ? '1px solid ' + alpha('#4395ff', 0.6) : 'none'
          }}>
          {showGenerate ?
            <Box sx={{ justifyContent: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <Typography sx={{ lineHeight: '1', color: theme.palette.common.white, fontSize: '14px', fontWeight: '400', display: 'block' }}>Generate or Manage Lineups</Typography>
            </Box>
            :
            <Box sx={{ justifyContent: 'space-between', display: 'inline-flex' }}>
              <Box sx={{ paddingRight: '12px', gap: '15px', display: 'flex', color: theme.palette.common.white, fontSize: '18px', fontWeight: '700' }}>
                Lineup {entry?.id + 1}
                {entry?.outcomes && entry?.outcomes[0] && (
                  <img src={`https://awesemostorage.blob.core.windows.net/assets/leagues/${league.toLowerCase()}.png`} alt="" style={{ height: '25px' }} />
                )}
              </Box>
              <Box sx={{ alignItems: 'center', gap: '10px', display: 'flex' }}>
                <Box sx={{ alignItems: 'center', display: 'flex' }}>
                  {entry?.outcomes?.map((leg, index) => (
                    <img src={leg.playerParticipantHeadShot} alt="" style={{ width: '25px', height: '25px', borderRadius: '20px', backgroundColor: '#004094', border: '1px #4395FF solid', marginLeft: '-8px' }} />
                  ))}
                  {entry?.outcomes && entry?.outcomes.length < 6 && [...Array(6 - entry.outcomes.length)].map((_, i) => {
                    return (<img src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" alt='' style={{ borderColor: alpha(theme.palette.common.white, 0.70), border: '0.50px dotted', marginLeft: '-8px', width: '25px', height: '25px', borderRadius: '20px', backgroundColor: '#1B1E25' }} />);
                  })}
                </Box>
                <Typography sx={{ color: theme.palette.common.white, fontSize: '14px', fontWeight: '400' }}>REVIEW PICKS</Typography>
              </Box>
            </Box>
          }
        </Box>
      </Box>
    </>
  )
}

export default MobileLineupSelector